import { ChangeControlComment } from '../../../../../api/changeControl';
import {
  HistoricalOpenCommentThread,
  HistoricalResolvedCommentThread,
} from '../HistoricalComments/HistoricalCommentThread';

interface HistoricalCommentThreadListProps {
  threads: HistoricalCommentThread[];
}

export type HistoricalCommentThread = ChangeControlComment & {
  replies: ChangeControlComment[];
};

export const HistoricalCommentThreadList = ({
  threads,
}: HistoricalCommentThreadListProps) => {
  return (
    <>
      {threads?.map((commentThread: HistoricalCommentThread) => {
        switch (commentThread.resolved) {
          case false:
            return (
              <HistoricalOpenCommentThread
                thread={commentThread}
                key={commentThread.id}
              />
            );
          case true:
            return (
              <HistoricalResolvedCommentThread
                thread={commentThread}
                key={commentThread.id}
              />
            );
          default:
            return <></>;
        }
      })}
    </>
  );
};
